import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

import _ from 'underscore';
import $ from 'jquery';

import { BindedView } from 'marionette.binding';

import AllContactsCollection from 'base/collections/contacts/all';
import ContactGroupCollection from 'base/collections/contacts/groups';
import PaginationView from 'base/views/page';
import DialogService from 'base/dialog_service';

import { Filter } from 'forms/filter/model';
import { FilterView } from 'forms/filter/view';

const Channel = Backbone.Wreqr.radio.channel('sfm.contacts').vent;

const EmptyView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/empty.html'),
  tagName: 'tr',
  templateHelpers() {
    return {
      state: this.getOption('collection').state
    };
  }
});

const ContactRowView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/row.html'),
  tagName: 'tr',

  ui: {
    checkbox: 'input'
  },

  triggers: {
    'click @ui.checkbox': 'check'
  },

  modelEvents: {
    change: 'render'
  },

  attributes() {
    var cls = '';
    if (this.getOption('odd') == 1) {
      cls = 'alt';
    }
    if (this.model.get('selected')) {
      cls += ' selected';
    }

    return {
      class: cls
    };
  },

  onRender() {
    $(this.el).prop(this.attributes());
  },

  templateHelpers() {
    return {
      groupString: this.model.displayGroupList(),
      hasJoinos: this.model.joinos(),
      giftAid: this.model.giftAid(),
      checked: this.model.get('selected') ? 'checked' : ''
    };
  },

  onCheck() {
    this.ui.checkbox.prop('disabled', 'disabled');
    const change = this.ui.checkbox.is(':checked');

    const filter = this.getOption('filter');
    const id = this.model.get('id');
    const url = `/names-filter/${filter}/names/${id}/?format=json`;

    $.post(
      url,
      {
        selected: change ? 'True' : 'False'
      },
      () => {
        this.model.set('selected', change);
        Channel.trigger('count', change ? 1 : -1);
      }
    ).always(() => {
      this.ui.checkbox.removeAttr('disabled');
    });
  }
});

const ContactAllView = Marionette.CompositeView.extend({
  template: require('base/templates/contacts/table.html'),
  childView: ContactRowView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    const opts = _.clone(this.options);
    opts.odd = index % 2;
    return opts;
  },

  collectionEvents: {
    state: 'render'
  },

  emptyView: EmptyView
});

const SelectedModalView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/selected_modal.html'),

  regions: {
    main: '.main-hook',
    filter: '.filter-hook',
    paginator: '.pagination-hook'
  },

  ui: {
    closeButton: '.close-button'
  },

  triggers: {
    'click @ui.closeButton': 'close'
  },

  onRender() {
    const mainView = new ContactAllView({
      collection: this.getOption('collection'),
      filter: this.getOption('filter')
    });
    this.showChildView('main', mainView);

    const paging = new PaginationView({
      collection: this.getOption('collection')
    });
    this.showChildView('paginator', paging);

    const filter = new FilterView({
      collection: this.getOption('collection'),
      model: new Filter()
    });
    this.showChildView('filter', filter);
  }
});

const SelectedCountView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/selected.html'),
  templateHelpers() {
    return {
      total: this.getOption('allCollection').state.totalRecords
    };
  },

  ui: {
    viewAll: '.view-all'
  },
  triggers: {
    'click @ui.viewAll': 'viewAll'
  },

  onViewAll() {
    const selectedCollection = new AllContactsCollection([], {
      filter: this.getOption('filter')
    });
    selectedCollection.search_params = {
      selected: 2
    };

    const selected = new SelectedModalView({
      collection: selectedCollection,
      filter: this.getOption('filter')
    });

    const modal = DialogService.show(selected);

    this.listenToOnce(selected, 'close', function () {
      modal.close();
      this.triggerMethod('refresh:collection');
    });

    selectedCollection.fetch();
  },

  initialize() {
    this.listenTo(this.getOption('allCollection'), 'sync', this.render);
  }
});

const LoadingView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/processing.html')
});

const GroupItemView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/group.html'),

  ui: {
    addButton: '.add-button'
  },

  triggers: {
    'click @ui.addButton': 'add'
  },

  templateHelpers() {
    return {
      mode: this.getOption('mode') || 'add'
    };
  }
});

export const GroupListView = Marionette.CollectionView.extend({
  childView: GroupItemView,
  childViewContainer: '.items',
  emptyView: EmptyView,

  collectionEvents: {
    state: 'render'
  },

  childViewOptions() {
    return this.options;
  },

  onChildviewAdd(x, child) {
    const loading = new LoadingView();
    const dlg = DialogService.show(loading);

    child.model.addToSelection().always(() => {
      this.trigger('refresh');
      this.trigger('close');
      Channel.trigger('refresh');
      dlg.close();
    });
  }
});

const ContactGroupView = Marionette.LayoutView.extend({
  template: require('base/templates/contacts/groups_layout.html'),
  regions: {
    main: '.main-hook',
    filter: '.filter-hook',
    paginator: '.pagination-hook'
  },

  ui: {
    closeButton: '.close-button'
  },

  triggers: {
    'click @ui.closeButton': 'close'
  },

  onRender() {
    const view = new GroupListView(this.options);

    this.listenTo(view, 'close', () => {
      this.modal.close();
    });

    const filter = new FilterView({
      collection: this.getOption('collection'),
      model: new Filter()
    });

    const paging = new PaginationView({
      collection: this.getOption('collection')
    });

    this.showChildView('main', view);
    this.showChildView('filter', filter);
    this.showChildView('paginator', paging);
  }
});

export default BindedView.extend({
  template: require('base/templates/contacts/layout.html'),

  regions: {
    paginator: '.paginator-hook',
    all: '.all-hook',
    selected: '.selected-items-hook',
    filter: '.filter-hook'
  },

  ui: {
    addGroupButton: '.add-group',
    addFilteredButton: '.add-filtered'
  },

  triggers: {
    'click @ui.addGroupButton': 'group',
    'click @ui.addFilteredButton': 'addFiltered'
  },

  childEvents: {
    'refresh:collection': 'resyncCollection'
  },

  onAddFiltered() {
    const total = this.allCollection.state.totalRecords;
    const msg = `Are you sure you wish to add ${total} names to your selection?`;

    if (confirm(msg)) {
      const loading = new LoadingView();
      const modal = DialogService.show(loading);

      this.allCollection.addToSelection().always(() => {
        modal.close();
        Channel.trigger('refresh');
      });
    }
  },

  onGroup() {
    const collection = new ContactGroupCollection([], {
      filter: this.getOption('filter')
    });

    const groupView = new ContactGroupView({
      collection,
      regionManager: this.rm
    });

    const modal = DialogService.show(groupView);

    groupView.on('close', () => {
      modal.close();
    });

    collection.fetch();
  },

  onRender() {
    // Start bindings!
    this.startBindings();

    this.allView = new ContactAllView({
      collection: this.allCollection,
      filter: this.getOption('filter')
    });
    this.showChildView('all', this.allView);

    // Paging for main collection
    const paging = new PaginationView({
      collection: this.allCollection
    });
    this.showChildView('paginator', paging);

    this.selectedView = new SelectedCountView({
      allCollection: this.selectedAllCollection,
      filter: this.getOption('filter')
    });
    this.showChildView('selected', this.selectedView);

    const filter = new FilterView({
      collection: this.allCollection,
      model: new Filter(),
      empty_on_filter: true
    });
    this.showChildView('filter', filter);
  },

  resyncCollection() {
    this.allCollection.fetch();
    this.selectedAllCollection.fetch();
  },

  initialize() {
    this.allCollection = new AllContactsCollection([], {
      filter: this.getOption('filter')
    });
    this.selectedAllCollection = new AllContactsCollection([], {
      filter: this.getOption('filter')
    });
    const query = this.getOption('query') || {};
    const searchParams = _.clone(query);
    const selectedParams = _.clone(query);
    selectedParams.selected = 2;
    this.allCollection.search_params = searchParams;
    this.selectedAllCollection.search_params = selectedParams;

    // Don't fetch if null
    if (!this.getOption('filter')) {
      return;
    }

    this.resyncCollection();

    Channel.on(
      'refresh',
      _.debounce(() => {
        this.allCollection.reset();
        this.resyncCollection();
      }, 1000)
    );

    Channel.on('count', c => {
      this.selectedAllCollection.state.totalRecords += c;
      try {
        this.selectedView.render();
      } catch (e) {
        /* pass */
      }
    });
  }
});



// WEBPACK FOOTER //
// ./base/views/contacts.js